import { render, staticRenderFns } from "./FakeLoading.vue?vue&type=template&id=3aaae0f8&scoped=true"
import script from "./FakeLoading.vue?vue&type=script&lang=js"
export * from "./FakeLoading.vue?vue&type=script&lang=js"
import style0 from "./FakeLoading.vue?vue&type=style&index=0&id=3aaae0f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaae0f8",
  null
  
)

export default component.exports